import React, {useState} from 'react';
import Form, {FormInputComponent} from "../../components/form/Form";
import {useAuth} from "../../providers/AuthProvider";
import {Radio, Space} from 'antd';
import {usePositionOverride} from "../../providers/PositionOverrideProvider";
import {usePosition} from "../../providers/ProjectPositionProvider";
import SpinLoader from "../../components/SpinLoader";
import {useProject} from "../../providers/ClientProjectProvider";

const hireTypeOptions = TB.map(laravel.talent_opp_hire_types, (info, key) => {
    return {
        label: key,
        value: key,
        help: info
    }
})
const PositionCandidateHireTypeOptionsModal = ({onClose}) => {
    const {auth} = useAuth();
    const {project} = useProject();
    const {position} = usePosition();

    const {updateContractTerms, isDisabled} = usePositionOverride();
    const candidate = position.assigned_candidate;
    const [hireType, setHireType] = useState(position.offeringHireType())

    const placeHolderOption = {label: 'Please select an option...', value: false, disabled:true};


    return (
        <SpinLoader isLoading={isDisabled}>
            <div>

                <React.Fragment>
                    <Form
                        background={'transparent'}
                        onChange={(params) => {
                            setHireType(params.hire_type);
                        }}
                        minimal
                        disabled={isDisabled}
                        onSubmit={async () => {
                            let updated = await updateContractTerms({hire_type:hireType});

                            if (updated) {
                                TB.toast("Updated Offering Hire Type", {type: 'success'});
                                return onClose();
                            }

                        }}
                        submitButton={false}
                        model={{hire_type: hireType}}
                    >
                        <FormInputComponent
                            type="antd-input"
                            value={hireType || false}
                            fieldName="hire_type"
                            label={false}
                            required={true}>
                            <Radio.Group
                                disabled={isDisabled}
                                value={hireType || ''}>
                                <Space direction="vertical" className="gap-10">

                                    {hireTypeOptions.map(option => (
                                        <Radio value={option.value} key={option.value}>
                                            <div className="flex flex-col gap-2">
                                                <span className="whitespace-no-wrap font-semibold text-primary">
                                                    {option.label}
                                                </span>
                                                <span className="text-xs">
                                                    {option.help}
                                                </span>
                                            </div>
                                        </Radio>
                                    ))}

                                </Space>
                            </Radio.Group>

                        </FormInputComponent>


                        <div className="flex mt-5 flex-row justify-end gap-3">

                            <button
                                type="button" disabled={isDisabled}
                                className="btn btn-outline-dark" onClick={onClose}>
                                Cancel
                            </button>

                            <button
                                type="submit"
                                disabled={isDisabled}
                                className="btn btn-primary">
                                Update
                            </button>
                        </div>
                    </Form>
                </React.Fragment>

            </div>
        </SpinLoader>
    );
}

export default PositionCandidateHireTypeOptionsModal;